import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@lciapps/auth';

@Component({
  selector: 'app-auth-callback',
  template: `
    <p>
      auth-callback works!
    </p>
  `,
  styleUrls: ['./auth-callback.component.scss']
})
export class AuthCallbackComponent implements OnInit {

  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {
    this.authService.completeAuthorization().then(user => {
      this.router.navigate(['/root/protected']);
    });
  }

}
